import styled, { css } from 'styled-components';
import { Slider } from '@mui/material';

import { colors } from '@/globalStyles';

export const ButtonWrapperStyled = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 2px;
  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${props => {
    if (props.$disabled) {
      return css`
        opacity: 0.5;
        cursor: default;
      `;
    }
    return css`
      opacity: 1;
      cursor: pointer;

      &:hover {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
        border-radius: 4px;
      }

      &:active, &:focus {
        color: ${colors.primary} !important;
      }
    `;
  }}
`;

export const SliderWrapperStyled = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 30px 100px 30px 50px;
  align-items: center;
  justify-content: center;
`;

export const ZoomSliderStyled = styled(Slider)`
  &.MuiSlider-root {
    padding: 0px;
  }

  & .MuiSlider-thumb {
    width: 16px;
    height: 16px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
    background-color: ${colors.primary};
  }

  & .MuiSlider-rail,
  & .MuiSlider-track {
    background-color: ${colors.quickSilver};
    opacity: 1;
  }
`;

export const ZoomSliderValueStyled = styled.span`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #666a6e;
  text-align: center;
`;
